<template>
  <div class="nomination-review">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="Review The Nomination"></ContentHeader>
        <h4 class="text-black-50">You've been identified to review the nomination for <router-link to="">{{nominationCategory}}</router-link> by:</h4>
        <div class="pt-2 mb-3">
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <a href="/index.php?page_id=164">{{nomination._embedded.author[0].name}}</a>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{nomination.nominator_details[0][0]['employee-company']}}</h6>
          <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> On:</span> {{ nominationDate }}</h6>
        </div>
        <div class="px-3 pb-3" v-if="this.nomination.isteamaward[0] == 'true'">
          Nominated Team Members:
          <ul>
            <li v-for="teams in nomination.nominationteam[0]" v-bind:key="teams.member_slug">
              <strong>{{teams.member_name}}</strong>
              Employee number: <strong>{{teams.member_employee_number}}</strong><br>
              Company: <strong>{{teams.member_company}}</strong><br>
            </li>
          </ul>
        </div>
        <div class="px-3 pb-3" v-else>
          <h4 class="text-black-50">For:</h4>
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <a href="/index.php?page_id=164">{{nomination.nominee_name[0]}}</a>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{nomination.nominee_company[0]}}</h6>
        </div>
        <hr>
        <h4 class="text-black-50">Nomination:</h4>
        <div class="mb-3" v-html="nomination.content.rendered"></div>
        <router-link v-if="nomination.supporting_documentation.length !== 0" :to="'/supporting-documentation/' + nomination.supporting_documentation" target="_blank" class="btn btn-primary mb-3">View supporting documentation</router-link>
        <hr>
        <div v-if="hierarchicalMessage.length > 1">
          <h4 class="text-black-30">Review Comments:</h4>
          <div class="hierarchicalMessage" v-for="messages in hierarchicalMessage" v-bind:key="messages.id">
            <span v-if="messages.project_sponsor_comment !== '' || messages.project_sponsor_status === 'Approve'">
              <h6><span class="text-black-50">{{workflowStagesLabel[workflowStages.indexOf(messages.project_sponsor_name.toLowerCase())]}}:</span></h6>
              <span>{{messages.project_sponsor_comment}}</span>
              <hr v-if="hierarchicalMessage.length > 1">
            </span>
          </div>
        </div>
        <div v-if="!stageApprove && $route.params.hasOwnProperty('level')">
          <div v-if="showSubstationFields">
            <h4 class="text-black-50 mb-4">Please complete the fields below in order to further complete the nomination.</h4>
            <div class="alert alert-danger" v-if="validationErrMsg !== ''">{{validationErrMsg}}</div>
            <Field150Word
              label="Add comments:"
              label-secondary=""
              :is-required="true"
              v-on:added150WordContent="populateFieldInput($event)"
              :display-field="true"
              error-class="">
            </Field150Word>
            <div class="row py-1">
              <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                <div class="form-group form-check">
                  <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                  <label for="terms" class="form-check-label">Accept the
                    <router-link to="/page/multichoice-recognition-terms-and-conditions" target="_blank">Terms &amp; Conditions</router-link>
                  </label>
                </div>
                <div v-if="termsNotAccepted" class="alert alert-danger">
                  Please accept the terms before Approving or Rejecting a nomination
                </div>
              </div>
            </div>
            <div class="row pt-2 mb-4">
              <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                <button type="button" class="btn btn-success btn-lg" v-on:click="acceptDecline('Approve')">
                  <i class="far fa-thumbs-up fa-fw"></i> Approve
                </button>
                <button type="button" class="btn btn-danger btn-lg" v-on:click="acceptDecline('Reject')">
                  <i class="far fa-thumbs-down fa-fw"></i> Reject
                </button>
                <a :href="downgradeURL" class="text-white">
                  <button type="button" class="btn btn-primary btn-lg">
                    Downgrade
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div v-if="!showSubstationFields" role="alert" class="alert alert-success">{{acceptDeclineMsg}}</div>
        </div>
        <div v-if="stageApprove && !displayHM">
          <div role="alert" class="alert alert-success" v-if="stageStatus === 'Approved'">
            You have <strong>{{stageStatus}}</strong> the nomination.
          </div>
          <div role="alert" class="alert alert-danger" v-if="stageStatus === 'Rejected'">
            You have <strong>{{stageStatus}}</strong> the nomination.
          </div>
        </div>
        <!-- <div v-if="nomination.teamnominationworkflow[0].project_sponsor_comment === 'Declined'">
          <strong>Your reason for declining</strong><br>
          {{nomination.teamnominationworkflow[0].project_sponsor_comment}}
        </div>
        <div v-if="nomination.teamnominationworkflow[0].project_sponsor_comment === 'Accepted'">
          <div v-if="nomination.substantiation_comments[0] !== ''">
            <strong>Your comments</strong><br>
            {{nomination.teamnominationworkflow[0].project_sponsor_comment}}
          </div>
        </div> -->
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import Field150Word from '@/components/Field150Word'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import NominationNotification from '@/helpers/NominationNotification.js'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    Field150Word
  },
  computed: {
    ...mapGetters([
      'getProfileDetails'
    ])
  },
  data () {
    return {
      contentReady: false,
      contentLoadError: '',
      nominationDate: '',
      nomination: {},
      nominationCategory: '',
      showSubstationFields: true,
      acceptDeclineMsg: '',
      nominatedComments: '',
      termsCheckbox: false,
      termsNotAccepted: false,
      nominationAccepted: false,
      nominationDeclineReason: '',
      stageStatus: '',
      award: [],
      validationErrMsg: '',
      stageApprove: false,
      workflowStages: [],
      workflowStagesLabel: [],
      nextStage: '',
      nextStageLabel: '',
      hierarchicalMessage: [],
      displayHM: true,
      downgradeURL: ''
    }
  },
  created () {
    console.log('profile details ', this)
    console.log('profile details username-> ', this.getProfileDetails)
    document.title = this.$route.name + ' - ThinkTank'
    this.downgradeURL = '/#/my-profile/downgrade-manager/'+this.$route.params.id
    WordpressRestAPI.getViewContent('nomination/' + this.$route.params.id + '?_embed')
      .then(response => {
        console.log('NominationReview', response.data)
        this.workflowStages = WordpressRestURI.workflowStages
        this.workflowStagesLabel = WordpressRestURI.workflowStagesLabel
        this.nomination = response.data
        this.getDate()
        console.log('isteamawards-> ' + this.nomination.isteamaward[0])
        if (this.nomination.isteamaward.includes('true')) {
          do {
            if (this.nomination.nominationteam[0].length === 1) {
              console.log('moved ->  ')
              this.nomination.nominationteam[0] = this.nomination.nominationteam[0][0]
            }
          } while (this.nomination.nominationteam[0].length === 1)
        }
        this.nominationCategory = response.data._embedded['wp:term'][1].map(x => x.name).filter(x => x !== 'VE Awards').join()
        this.contentReady = true
        this.nominationAccepted = response.data.nomination_approve_decline[0] === 'Accepted'
        var currentStage = this.nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === this.$route.params.level.toLowerCase())
        if (currentStage[0].hasOwnProperty('project_sponsor_status')) {
          if (currentStage[0]['project_sponsor_status'] === 'Approve') {
            this.stageApprove = (currentStage[0]['project_sponsor_status'] === 'Approve')
            this.stageStatus = 'Approved'
          } else if (currentStage[0]['project_sponsor_status'] === 'Reject') {
            this.stageApprove = (currentStage[0]['project_sponsor_status'] === 'Reject')
            this.stageStatus = 'Rejected'
          }

          if (this.$route.params.level !== '') {
            var self = this
            // this.displayHM = (this.$route.query.status === 'review')
            // this.hierarchicalMessage = this.nomination.teamnominationworkflow[0].filter(r => r.project_sponsor_comment.indexOf('Rejected by') === -1 || r.project_sponsor_comment.trim() !== '')
            this.hierarchicalMessage = this.workflowStages.map( function(r) {
              return self.nomination.teamnominationworkflow[0].filter(t => t.project_sponsor_name.toLowerCase() === r)[0]
            })
            // Remove duplicate for 
            this.hierarchicalMessage = this.hierarchicalMessage.filter(function(t){ return t !== undefined })
          }
        }
        if (this.nomination.isteamaward.includes('true')) {
          var categorySlug = response.data.slug.split('-by')[0] // TODO: FIND A VALID SLUG
          // BELOW CALL is required to pull data for Mail Body
          WordpressRestAPI.getViewContent('nomination_event?slug=' + categorySlug + '&_embed')
            .then(response => {
              this.award = response.data[0]
              console.log('Awards in NR', this.award)
            })
            .catch(e => {
              console.error(e)
            })
        }
        // this.updateNomination('Declined')
        console.log(this.nominationAccepted + ' <- status')
      })
      .catch(e => {
        this.childContentLoadError = 'Oops! We had a problem with loading your nomination. Please try again later.'
        console.error(e)
      })
  },
  methods: {
    getDate: function() {
      let d = this.nomination.date.split('T')
      let options = {year: "numeric", month: "short", day: "numeric"};
      this.nominationDate = new Intl.DateTimeFormat('en-US', options).format(new Date(d[0]))
    },
    nthDate: function(d) {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
      }
    },  
    populateFieldInput: function (content) {
      if (content.label === 'Add comments:') {
        this.nominatedComments = content.content
      }
    },
    promoteNomiationtoNextStage: function (status) {
      let emailBody = ''
      var tempEmail = []
      if (status === 'Reject') {
        // TODO: Change the Email template once received
        emailBody = NominationNotification.nominationBodyHRBPForRejection({
          reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-manager+' + this.$route.params.id + '+' + this.nextStage + '?status=review',
          position: this.nextStageLabel
        })
        tempEmail = this.nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === this.workflowStages[3])
      } else if (status === 'Approve') {
        emailBody = NominationNotification.nominationBodyProjectSponsorWithReview({
          reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-manager+' + this.$route.params.id + '+' + this.nextStage,
          position: this.nextStageLabel
        })
        tempEmail = this.nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === this.nextStage)
      }
      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: tempEmail[0].project_sponsor_email,
          subject: 'You have been identified as ' + this.nextStageLabel + ' on ThinkTank',
          message: emailBody
        },
        json: true
      }

      WordpressRestAPI.sendEmail(emailNominationNotification)
        .then(function (response) {
          console.log(response.data)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    acceptDecline: function (status) {
      var self = this
      self.validationErrMsg = ''
      if (self.termsCheckbox || status === 'Reject') {
        self.termsNotAccepted = !self.termsCheckbox
        if (status === 'Approve' && self.termsCheckbox) {
          self.validationErrMsg = ''
          self.updateNomination(status)
        } else if (self.nominatedComments.trim() == "") {
          self.validationErrMsg = 'Please provide Rejection Reason/Comment!'
        } else if (self.termsCheckbox) {
          self.validationErrMsg = ''
          self.updateNomination(status)
        }
      } else {
        self.termsNotAccepted = true
      }
    },
    sentNominatorNotification: function (status = 'Approve') {
      WordpressRestAPI.getViewContent('users/' + this.nomination.author + '?&_embed')
        .then(response => {
          var nominationEmail = response.data.user_email
          var nominationName = response.data.name
          // GET CATEGORY NAME
          if (this.nomination.isteamaward.length > 0 && this.nomination.nominationteam[0] !== null) {
            if (this.nomination._embedded['wp:term'][0].filter(d => d.id === 104).length > 0 ) {
              var awardName = this.nomination._embedded['wp:term'][0].filter(d => d.id === 104)[0].name
            } else if (this.nomination._embedded['wp:term'][1].filter(d => d.id === 104).length > 0 ) {
              var awardName = this.nomination._embedded['wp:term'][1].filter(d => d.id === 104)[0].name
            }
          } else {
            if (this.nomination._embedded['wp:term'][0].filter(d => d.id === 103).length > 0 ) {
              var awardName = this.nomination._embedded['wp:term'][0].filter(d => d.id === 103)[0].name
            } else if (this.nomination._embedded['wp:term'][1].filter(d => d.id === 103).length > 0 ) {
              var awardName = this.nomination._embedded['wp:term'][1].filter(d => d.id === 103)[0].name
            }
          }

          var d = new Date(this.nomination.date)
          var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

              // to: 'deenanath.mishra@nihilent.com',
          var emailNominationNotification = {
            method: 'POST',
            data: {
              to: nominationEmail,
              subject: 'CONGRATULATIONS: #WeSeeYou Recognition Award Confirmation',
              message: ''
            },
            json: true
          }

          if (status === 'Reject') {
            emailNominationNotification.data.message = NominationNotification.nominatorRejectionConfirmation({
              nominee: nominationName,
              awardName: awardName,
              submissionDate: d.getDate() + this.nthDate(d.getDate()) + " of " + months[d.getMonth()] + ' ' + d.getFullYear()
            })
            emailNominationNotification.data.subject = 'NOTIFICATION: #WeSeeYou Recognition Award Confirmation'
          } else {
            emailNominationNotification.data.message = NominationNotification.nominatorConfirmation({
              nominee: nominationName,
              awardName: awardName,
              reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-nomination+' + this.$route.params.id,
              submissionDate: d.getDate() + this.nthDate(d.getDate()) + " of " + months[d.getMonth()] + ' ' + d.getFullYear()
            })
          }

          WordpressRestAPI.sendEmail(emailNominationNotification)
            .then(function (response) {
              console.log(response.data)
            })
            .catch(function (e) {
              console.error(e)
            })
      })
      .catch(e => {
        console.error(e)
        return '';
      })        
    },
    sentNomineeNotification: function () {
      WordpressRestAPI.getViewContent('employeehierarchy?slug=' + this.nomination.nominee_slug[0] + '&_embed')
        .then(response => {
          var nomineeEmail = response.data[0].title.rendered
          var nomineeName = this.nomination.nominee_name[0]
          // GET CATEGORY NAME
          if (this.nomination._embedded['wp:term'][0].filter(d => d.id === 103).length > 0 ) {
            var awardName = this.nomination._embedded['wp:term'][0].filter(d => d.id === 103)[0].name
          } else if (this.nomination._embedded['wp:term'][1].filter(d => d.id === 103).length > 0 ) {
            var awardName = this.nomination._embedded['wp:term'][1].filter(d => d.id === 103)[0].name
          }

          let emailBody = NominationNotification.nomineeConfirmation({
            nominee: nomineeName,
            awardName: awardName,
            reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-nomination+' + this.$route.params.id,
          })
              // to: 'deenanath.mishra@nihilent.com',
          var emailNominationNotification = {
            method: 'POST',
            data: {
              to: nomineeEmail,
              subject: 'CONGRATULATIONS: #WeSeeYou Recognition Award Confirmation',
              message: emailBody
            },
            json: true
          }

          WordpressRestAPI.sendEmail(emailNominationNotification)
            .then(function (response) {
              console.log(response.data)
            })
            .catch(function (e) {
              console.error(e)
            })
      })
      .catch(e => {
        console.error(e)
        return '';
      })        
    },
    sentTeamNomineeNotification: function(memberId = 0) {
      var self= this
      if (self.nomination._embedded['wp:term'][0].filter(d => d.id === 104).length > 0 ) {
        var awardName = self.nomination._embedded['wp:term'][0].filter(d => d.id === 104)[0].name
      } else if (self.nomination._embedded['wp:term'][1].filter(d => d.id === 104).length > 0 ) {
        var awardName = self.nomination._embedded['wp:term'][1].filter(d => d.id === 104)[0].name
      }

      if (memberId < self.nomination.nominationteam[0].length) {
      // for (var i=memberId; i <= this.nomination.nominationteam.length; i++) {
        let emailBody = NominationNotification.nomineeConfirmation({
          nominee: self.nomination.nominationteam[0][memberId].member_name,
          awardName: awardName,
          reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-nomination+' + self.$route.params.id,
        })
      WordpressRestAPI.getViewContent('employeehierarchy?slug=' + self.nomination.nominationteam[0][memberId].member_slug + '&_embed')
        .then(response => {
            // to: 'deenanath.mishra@nihilent.com',
          var emailNominationNotification = {
            method: 'POST',
            data: {
              to:  response.data[0].title.rendered,
              subject: 'CONGRATULATIONS: #WeSeeYou Recognition Award Confirmation',
              message: emailBody
            },
            json: true
          }

          WordpressRestAPI.sendEmail(emailNominationNotification)
            .then(function (response) {
              console.log(response.data)
              memberId++
              self.sentTeamNomineeNotification(memberId)
            })
            .catch(function (e) {
              console.error(e)
            })
        })
        .catch(function (e) {
          console.error(e)
        })
      }
    },
    updateNominatorNominee: function () {
      if (this.nomination.nomination_event_category[0] === 104 || this.nomination.nomination_event_category[1] === 104) {
        this.sentNominatorNotification()
        this.sentTeamNomineeNotification()    
      }
      else if (this.nomination.nomination_event_category[0] === 103 || this.nomination.nomination_event_category[1] === 103) {
        // 103 - On the Spot for live
        this.sentNominatorNotification()
        this.sentNomineeNotification()
      }
    },
    sentRejectNotificationtoWorkflow: function(nomination, stage = false) {
      var self = this
      let rejectedStage = self.workflowStages.indexOf(self.$route.params.level.toLowerCase())
      if (stage === false) stage = rejectedStage - 1
      let nomineeName = '';
      if (nomination.nominationteam[0] !== null) {
        //Team Nomination
        nomineeName = nomination.nominationteam[0][0].member_name + ' and Team'
      } else {
        nomineeName = nomination.nominee_name[0]
      }

      let tempEmail = nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === self.workflowStages[stage].toLowerCase())

      let emailBody = NominationNotification.workflowNotificationForRejection({
        nominee: nomineeName,
        level: self.workflowStagesLabel[rejectedStage]
      })
          // to: 'deenanath.mishra@nihilent.com',
      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: tempEmail[0].project_sponsor_email,
          subject: 'NOTIFICATION: #WeSeeYou Recognition Award Confirmation',
          message: emailBody
        },
        json: true
      }

      // console.log('Mail',emailNominationNotification)
      WordpressRestAPI.sendEmail(emailNominationNotification)
        .then(function (response) {
          console.log(response.data)
          if (stage !== 0)
            self.sentRejectNotificationtoWorkflow(nomination, stage - 1)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    updateRejectionNotification: function(nomination) {
      this.sentNominatorNotification('Reject')
      this.sentRejectNotificationtoWorkflow(nomination)
    },
    updateNomination: function (status) {
      var self = this
      var sendNominationPS = {
        method: 'POST',
        data: {},
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      sendNominationPS.data.teamnominationworkflow = []
      var d = new Date()
      for (var i = 0; i < self.nomination.teamnominationworkflow[0].length; i++) {
        // UPDATE CURRENT STATUS
        if (self.nomination.teamnominationworkflow[0][i].project_sponsor_name.toLowerCase() === self.$route.params.level.toLowerCase()) {
          sendNominationPS.data.teamnominationworkflow.push({
            'project_sponsor_email': self.nomination.teamnominationworkflow[0][i].project_sponsor_email,
            'project_sponsor_status': status,
            'project_sponsor_comment': self.nominatedComments,
            'project_sponsor_name': self.nomination.teamnominationworkflow[0][i].project_sponsor_name,
            'project_sponsor_datetime': d.getFullYear() + '-' + parseInt(parseInt(d.getMonth()) + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
          })
        } else {
          // RESTORE UNCHANGE VALUES
          if (status === 'Reject' && self.workflowStages.indexOf(self.nomination.teamnominationworkflow[0][i].project_sponsor_name.toLowerCase()) > self.workflowStages.indexOf(self.$route.params.level.toLowerCase())) {
            sendNominationPS.data.teamnominationworkflow.push({
              'project_sponsor_email': self.nomination.teamnominationworkflow[0][i].project_sponsor_email,
              'project_sponsor_comment': 'Rejected by ' + self.workflowStagesLabel[self.workflowStages.indexOf(self.$route.params.level.toLowerCase())],
              'project_sponsor_status': status,
              'project_sponsor_name': self.nomination.teamnominationworkflow[0][i].project_sponsor_name,
              'project_sponsor_datetime': self.nomination.teamnominationworkflow[0][i].project_sponsor_datetime
            })
          } else {
            sendNominationPS.data.teamnominationworkflow.push({
              'project_sponsor_email': self.nomination.teamnominationworkflow[0][i].project_sponsor_email,
              'project_sponsor_comment': self.nomination.teamnominationworkflow[0][i].project_sponsor_comment,
              'project_sponsor_status': self.nomination.teamnominationworkflow[0][i].project_sponsor_status,
              'project_sponsor_name': self.nomination.teamnominationworkflow[0][i].project_sponsor_name,
              'project_sponsor_datetime': self.nomination.teamnominationworkflow[0][i].project_sponsor_datetime
            })
          }
        }
      }
      WordpressRestAPI.endpointWithAuthetication(sendNominationPS, 'nomination/' + self.$route.params.id)
        .then(function (response) {
          self.showSubstationFields = false
          self.stageStatus = (status === 'Approve' ? 'Approved' : (status === 'Reject' ? 'Rejected' : status))
          self.acceptDeclineMsg = 'You have ' + status + ' the nomination'
          self.stageApprove = true
          if (status === 'Approve') {
            var nextStageTemp = 0
            for (var s = 0; s < self.workflowStages.length; s++) {
              if (self.workflowStages[s] === self.$route.params.level.toLowerCase()) {
                nextStageTemp = s + 1
              }
            }
            self.nextStage = self.workflowStages[nextStageTemp]
            self.nextStageLabel = self.workflowStagesLabel[nextStageTemp]
            if (self.workflowStagesLabel[nextStageTemp]) {
              self.promoteNomiationtoNextStage(status)
            } else if (nextStageTemp === 4) {
              // Approved By HRBP
              self.updateNominatorNominee()
            }
          } else if (status === 'Reject') {
            self.nextStage = self.workflowStages[3]
            self.nextStageLabel = self.workflowStagesLabel[3]
            self.promoteNomiationtoNextStage(status)
            self.updateRejectionNotification(response.data)
          }
        })
        .catch(function (e) {
          console.error(e)
        })
    }
  },
  watch: {
    immediate: true,
    deep: true,
    getProfileDetails (newDetails, oldDetails) {
      var self = this
      var levelStatus = self.nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === self.$route.params.level.toLowerCase())
      if (self.getProfileDetails.username && self.getProfileDetails.email.toLowerCase().trim() !== levelStatus[0].project_sponsor_email.toLowerCase().trim() && self.getProfileDetails.username.toLowerCase().trim() !== levelStatus[0].project_sponsor_email.toLowerCase().trim()) {
        console.log('Invalid user REDirect!')
        console.log('getProfileDetails email ', self.getProfileDetails.email.toLowerCase().trim(), ' sponsor email ', levelStatus[0].project_sponsor_email.toLowerCase().trim(), self.getProfileDetails.username.toLowerCase().trim(), self.$route.params.level.toLowerCase())
        this.$router.push('/')
      } else if (self.getProfileDetails.email.toLowerCase().trim() !== levelStatus[0].project_sponsor_email.toLowerCase().trim()) {
          console.log('getProfileDetails email ', self.getProfileDetails.email.toLowerCase().trim(), ' sponsor email ', levelStatus[0].project_sponsor_email.toLowerCase().trim(), self.$route.params.level.toLowerCase())
          console.log('Invalid user REDirect!')
          this.$router.push('/')
        } else if (self.nomination.nomination_approve_decline[0] !== 'Accepted') {
        this.$router.push('/')
      } else if (levelStatus.length === 0) {
      // variable length will be 0 where approval statges are not set
        this.$router.push('/')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/NominationSponsorReview.vue